import axios from 'axios';

export const state = {};

export const mutations = {};

export const actions = {
  async downloadFile(context, data) {
    const options = {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf',
      },
    };

    return axios
      .get(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/documents/admin/${data.userId}/${data.documentId}`, options)
      .then(response => response.data);
  },
};

const userDocumentsStore = {
  state,
  mutations,
  actions,
};

export default userDocumentsStore;



// WEBPACK FOOTER //
// ./src/store/ire/userDocumentsStore.js